import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-signpost"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createElementVNode("g", { class: "" }, [
      _createElementVNode("polygon", {
        points: "30.6,21 8.8,21 8.8,11.7 30.6,11.7 35.2,16.4 30.6,21 \t",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      }),
      _createElementVNode("polyline", {
        points: "21,21 21,32.3 18.4,32.3 18.4,21 \t",
        class: "icon-fi--no-fill icon-fi--with-stroke"
      })
    ], -1)
  ]), 16))
}
export default { render: render }